import { IEmailAttachment } from 'Modules/Communication/Email/shared/models/Email'
import { FileWrapper } from 'shared/components/FileuploadPicker/types/types'

export const mapEmailAttachmentsToFileWrappers = (
  emailAttachments: IEmailAttachment[]
): FileWrapper[] => {
  return (
    emailAttachments?.map((attachment) =>
      mapEmailAttachmentToFileWrapper(attachment)
    ) || []
  )
}

export const mapEmailAttachmentToFileWrapper = (
  emailAttachment: IEmailAttachment
): FileWrapper => {
  return {
    id: emailAttachment.attachmentId,
    isLocal: false,
    isExisting: true,
    isArchive: false,
    file: undefined,
    mimeType: emailAttachment.contentType,
    name: emailAttachment.filename,
    url: emailAttachment.downloadUrl,
  }
}
